export const initializeReadMore = () => {
    const readMoreContainer = document.querySelector('.labs-disclaimer__read-more');
    const readMoreBtn = document.querySelector('.labs-disclaimer__read-more-btn');
    const disclaimerContent = document.querySelector('.labs-disclaimer__container');

    function adjustReadMore() {
      disclaimerContent.style.overflow = 'hidden';

      const { scrollHeight, clientHeight } = disclaimerContent;
      if (scrollHeight > clientHeight) {
        readMoreContainer.style.display = 'flex';
      }
      else {
        readMoreContainer.style.display = 'none';
      }
    }

    readMoreBtn.addEventListener('click', () => {
      disclaimerContent.style.overflow = 'auto';
      disclaimerContent.style.paddingBottom = '40px';

      readMoreContainer.style.display = 'none';
      
      window.removeEventListener('resize', adjustReadMore);
    });

    

      adjustReadMore();
      
      window.addEventListener('resize', adjustReadMore);
};